import { EntityState } from "@ngrx/entity";

export interface DashboardPage {
  id: number;
  name: string;
}

export interface DashboardPageModel {
  id: number;
  parentId: number;
  isEnabled: boolean;
  displayName: string;
  route: string;
  order: number;
}

export interface Role {
  id: number;
  displyName: string;
}

export enum RoleEnum {
  administrator = 'administrator',
  businessInternalUser = 'businessinternaluser',
  clientAdministrator = 'clientadministrator',
  clientUser = 'clientuser',
  dealerCredit = 'dealercredit',
  supportUser = 'supportuser',
}

// MOVE TO ROLE PERMISSION
export interface RolePermission {
  createdDateTime: Date;
  dashboardPage: DashboardPage;
  dashboardPageId: number;
  id: number;
  isEnabled: boolean;
  lastUpdatedBy: string;
  pageId: number;
  permission: any;
  permissionId: number;
  role: Role;
  roleId: number;
  updatedDateTime: Date;
}

export interface RoleState extends EntityState<Role> {
  error: string;
  loaded: boolean;
  loading: boolean;
  selectedRoleId: number | null;
}

export class RoleViewModel {
  id: number;
  name: string;
  description: String;
  displayName: string;
  clientInfoId:number;
  genericRoleId : number;
  isInternal : boolean;
  dashboardPages : DashboardPageModel[];
}
